module.exports = __webpack_public_path__ + "static/media/avatar.f5e525e6.png";